import {
  Button,
  Col,
  EditButton,
  Form,
  Icons,
  Input,
  List,
  Row,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { CrudFilters, IResourceComponentsProps } from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import dayjs from "dayjs";
import useMediaScreen from "hooks/useMediaScreen";
import React, { useEffect, useState } from "react";
import { ISubscriptionApplicationsResponse } from "types/subscriptionApp.interface";
import { getOrderNumber } from "utils";

export const DisputeList: React.FC<IResourceComponentsProps> = () => {
  const [resource, setResource] = useState("disputes");
  const { isMobile } = useMediaScreen();

  const { tableProps, searchFormProps }: any =
    useTable<ISubscriptionApplicationsResponse>({
      resource: resource,
      onSearch: (params) => {
        const filters: CrudFilters = [];
        const input = params;
        filters.push({
          field: "search",
          operator: "in",
          value: input,
        });
        return filters;
      },
    });

  const current = tableProps?.pagination?.current;
  const pageSize = tableProps?.pagination?.pageSize;

  useEffect(() => {
    if (tableProps?.dataSource?.length === 0) {
      setResource("disputes");
    }
  }, [tableProps]);

  return (
    <List>
      <Row style={{ display: "block" }}>
        <Col>
          <Form layout="vertical" {...searchFormProps}>
            <Form.Item
              label="Search"
              name="search"
              style={{ width: isMobile ? "100%" : "50%" }}
              initialValue=""
            >
              <Input
                placeholder="Paypal Case ID, Paypal Email, Paypal Transaction ID "
                prefix={<Icons.SearchOutlined />}
              />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  Filter
                </Button>
              </Form.Item>
              <ButtonExport path="disputes" />
            </div>
          </Form>
        </Col>
        <Col>
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="_id"
              key="_id"
              title="Index"
              render={(value, item, index) => (
                <TextField value={getOrderNumber(current, pageSize, index)} />
              )}
            />
            <Table.Column
              dataIndex="order"
              key="order"
              title="Order ID"
              render={(value) => <TextField value={value?.orderId} />}
            />
            <Table.Column
              dataIndex="transactionAmount"
              key="transactionAmount"
              title="Transaction Amount($)"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="user"
              key="user"
              title="User Email"
              render={(value) => <TextField value={value?.email} />}
            />
            <Table.Column
              dataIndex="paypalEmail"
              key="paypalEmail"
              title="Paypal Email"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="paypalTransactionId"
              key="paypalTransactionId"
              title="Paypal Transaction ID"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="paypalTransactionDate"
              key="paypalTransactionDate"
              title="Paypal Transaction Date"
              render={(value) => (
                <TextField value={dayjs(value).format("MM-DD-YYYY HH:mm A")} />
              )}
            />
            <Table.Column
              dataIndex="paypalCaseId"
              key="paypalCaseId"
              title="Paypal Case ID"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="comments"
              key="comments"
              title="Comments"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="isResolved"
              key="isResolved"
              title="Resolved"
              render={(value) => <TextField value={value ? "Yes" : "No"} />}
            />
            <Table.Column
              dataIndex="refundType"
              key="refundType"
              title="Refund Type"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="refundAmount"
              key="refundAmount"
              title="Refund Amount"
              render={(value) => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="createdAt"
              key="createdAt"
              title="Created At"
              render={(value) => (
                <TextField value={dayjs(value).format("MM-DD-YYYY HH:mm A")} />
              )}
            />
            <Table.Column
              dataIndex="action"
              key="action"
              title="Action"
              render={(_, record: any) => (
                <Space>
                  <EditButton hideText size="small" recordItemId={record._id} />
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </List>
  );
};
